import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Regular from "./Roboto-Regular.woff2";

export const RobotoRegularFontFaces: ExcalidrawFontFaceDescriptor[] = [
  { uri: Regular },
];
